
export default
[
    { text: 'Sampled before filter change', value: 'BEFORE' },
    { text: 'Sampled after filter change', value: 'AFTER' },
    { text: 'Unknown or not applicable', value: 'UNKNOWN' }
];